import React from "react";
import "../App.css"; 
const Home = () => {
  return (
    <div className="container">
      <h1>My Journey into Cybersecurity</h1>

      <p>
        Starting a career in cybersecurity comes with its highs and lows — but in my experience, the benefits
        definitely outweigh the challenges.
      </p>

      <p>
        First off, there's a lot of learning involved. You’ll find yourself hitting the books (or online tutorials),
        keeping a journal (if that's your thing), and constantly revisiting concepts. Hands-on labs, practice tests,
        and quizzes really help to solidify the knowledge. And eventually, you’ll want to narrow your focus. For me,
        I chose to specialize as a <strong>Cybersecurity Analyst</strong>.
      </p>

      <p>
        My background as a researcher gave me several transferable skills that have made the transition easier and more
        rewarding.
      </p>

      <p>
        There are tons of courses out there to build your foundation. I’ve put together a list — and yes, it might seem
        like a lot, but remember: <strong>go big or go home</strong>. Here are some essentials:
      </p>

      <ul>
        <li>Computer Hardware Basics</li>
        <li>Cybersecurity Fundamentals</li>
        <li>Python Programming</li>
        <li>Network Defense</li>
        <li>Endpoint Security</li>
        <li>Ethical Hacking</li>
      </ul>

      <p>More courses coming soon in the next post!</p>

      <p>
        Mastering these topics will set you up to handle real-world cyber threats confidently. Plus, you’ll be able to
        hold deep conversations with fellow cybersecurity enthusiasts, educate those around you on safe practices, and
        mentor the next generation.
      </p>

      <h2>Fun Cybersecurity Terminology</h2>
      <p>
        During my study sessions, I stumbled on some alternative names for common cybersecurity terms. They're fun,
        catchy, and great for making presentations more engaging:
      </p>

      <ul>
        <li>Hacker → <strong>Cyber Ninja</strong> or <strong>Digital Samurai</strong></li>
        <li>Malware → <strong>Digital Gremlins</strong></li>
        <li>Firewall → <strong>Cyber Fortress</strong></li>
        <li>Phishing → <strong>Digital Baiting</strong></li>
        <li>Encryption → <strong>Data Armor</strong></li>
        <li>Vulnerability → <strong>System Chink</strong></li>
        <li>Penetration Testing → <strong>Cyber Siege</strong> or <strong>Red Team Maneuvers</strong></li>
        <li>Incident Response → <strong>Breach Containment</strong></li>
        <li>Zero-Day Exploit → <strong>Day Zero Threat</strong> or <strong>Cyber Bombshell</strong></li>
        <li>Data Breach → <strong>Info Leak</strong> or <strong>Data Spill</strong></li>
        <li>Botnet → <strong>Zombie Army</strong></li>
        <li>Ransomware → <strong>Digital Hostage</strong></li>
        <li>Social Engineering → <strong>Human Hacking</strong></li>
        <li>2FA → <strong>Double Lockdown</strong></li>
        <li>White Hat Hacker → <strong>Ethical Cyber Warrior</strong></li>
        <li>Dark Web → <strong>Digital Underworld</strong></li>
        <li>Spyware → <strong>Cyber Stalker</strong></li>
        <li>DDoS Attack → <strong>Cyber Blitzkrieg</strong></li>
        <li>Security Patch → <strong>System Band-Aid</strong></li>
        <li>Security Audit → <strong>Cyber Checkup</strong></li>
      </ul>

      <p>
        These creative terms are a fun way to make cybersecurity discussions more relatable — especially when speaking
        with non-tech folks.
      </p>

      <p>That’s all for now. See you in the next post — stay safe online!</p>

      {/* Adware/Ad placeholder */}
      <div style={{ margin: "24px 0", textAlign: "center" }}>
        <iframe
          src="https://www.profitableratecpm.com/zyytgvm9c?key=ba0da573e23eae3449388338d837bf71"
          title="Advertisement"
          width="320"
          height="50"
          style={{ border: "none", overflow: "hidden" }}
          scrolling="no"
          frameBorder="0"
        ></iframe>
      </div>
    </div>
  );
};

export default Home;